import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateGame from '@/modules/game/api/hooks/useMutationUpdateGame'
import { GetGameListTableData } from '@/modules/game/type'
import { useQueryClient } from '@tanstack/react-query'
import { GameQueryKeys } from '@/modules/game/keys'

interface IsActiveGameProps {
	row: GetGameListTableData
}

export function IsActiveGame({ row }: IsActiveGameProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateGame } = useMutationUpdateGame()

	const handleMutate = async (value: boolean) => {
		await updateGame({
			id: row.id,
			payload: {
				isActive: value,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameList],
		})
	}

	return <SetIsActive defaultChecked={row.isActive} onMutate={handleMutate} />
}
